import Vue from 'vue';
import { i18n } from '../vendors/vue-i18n';

Vue.filter('currencyFromCents', value => {
    let symbol = document.getElementById("currency_symbol").value;
    return symbol + ''+ parseFloat(value / 100).toFixed(2);
});

Vue.filter('activeCurrencyFromCents', value => {
    let result = parseFloat(value) * Shopify.currency.rate;
    let symbol = document.getElementById("currency_symbol").value;
    return symbol + ''+ parseFloat(result / 100).toFixed(2);
});

Vue.filter('activeCurrency', value => {
    let result = parseFloat(value * 100) * Shopify.currency.rate;
    let symbol = document.getElementById("currency_symbol").value;
    return symbol + ''+ parseFloat(result / 100).toFixed(2);
});